// TODO: Support delayed GC (5-10min timeout)
// TODO: Write updated states to indexeddb in a batch
export const createEntityCache = () => {
  const cache = new Map();
  return {
    get: (entity, instanceKey) => {
      var _cache$get;
      return (_cache$get = cache.get(entity.typeIdentifier)) === null || _cache$get === void 0 ? void 0 : _cache$get.get(instanceKey);
    },
    set: (entity, instanceKey, data) => {
      if (!cache.has(entity.typeIdentifier)) {
        cache.set(entity.typeIdentifier, new Map());
      }
      cache.get(entity.typeIdentifier).set(instanceKey, data);
    }
  };
};